import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/wordCityConstants';

import { getRoundTower } from './wordCitySelectors';

const initialState = {
  currentStepIndex: null,
  standardItems: [],
  tower: [],
  progress: 0,
  roundLevelId: null,
};

const wordCityStandardRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_STANDARD_ROUND: {
      const { standardItems, roundLevelId } = action.payload;

      return {
        ...initialState,
        standardItems,
        roundLevelId,
        currentStepIndex: 0,
        // initialState, not state: a null currentStepIndex is what starts the tower at one floor
        tower: getRoundTower({
          ...initialState,
          standardItems,
        }),
      };
    }
    case REDUX_ACTIONS.NEXT_STANDARD_STEP: {
      const nextStepIndex = state.currentStepIndex + 1;

      return {
        ...state,
        currentStepIndex: nextStepIndex === state.standardItems.length ? null : nextStepIndex,
      };
    }
    case REDUX_ACTIONS.DISCONTINUE_STANDARD_ROUND: {
      return {
        ...state,
        currentStepIndex: null,
      };
    }
    case REDUX_ACTIONS.BUILD_STANDARD_TOWER: {
      return {
        ...state,
        tower: getRoundTower(state),
      };
    }
    case REDUX_ACTIONS.MARK_PROGRESS: {
      // if answer was correct (true) - increment is 1, if no (false) - increment is 0
      const progressIncrement = +action.payload;

      return {
        ...state,
        progress: state.progress + progressIncrement,
      };
    }
    case REDUX_ACTIONS.QUICK_ROUND: {
      const num = state.standardItems.length;
      const numCorrect = action.payload ? num : 0;
      return {
        ...state,
        progress: numCorrect,
        currentStepIndex: null,
      };
    }
    default:
      return state;
  }
};

export default wordCityStandardRoundReducer;
